import { Popup, useMap } from "react-leaflet"
import React, { useContext, useEffect, useRef, useState } from "react"
import { HelpersContext } from "../../context";
import ListItemsControl from "../controls/old/ListItemsControl";

export const MarkerPopup = props => {
    const [isRealatedOpen, setIsRelatedOpen] = useState(false)
    const popup = useRef()
    const { host } = props




    return (
        <Popup key={props.k} maxWidth={400} ref={popup} eventHandlers={{ remove: (p) => setIsRelatedOpen(false)  }} autoClose={false} >
            <div id='list-items'></div>
            <div key={'popup_header'} className='popup_header'>
                <span className="popup_line" style={{ fontWeight: 600, textAlign: 'center', width: '100%', maxWidth: '350px', marginBottom: '10px' }}>
                    {props.prefix ? props.prefix : ''}{host.name ? host.name : host.tp} {host.geodecode_display_name}{host.nickname ? ` (${host.nickname})` : ''}
                </span>
            </div>
            <div key={'popup_body'} className='popup_body'>
                {
                    props.ps ?
                        <>
                            <span className="popup_line" ><b>Подстанция:  </b>{props.ps.name}</span>

                        </>
                        : null

                }

            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {
                    props.position ?
                        <button className="btn btn-outline-secondary popup-button" onClick={() => window.open(`https://yandex.ru/maps/?whatshere[point]=${props.position[1]},${props.position[0]}&whatshere[zoom]=17`)}>
                            <span className="material-icons" style={{ fontSize: '22px' }}>mode_of_travel</span>
                        </button> : <div></div>
                }

                <button className="btn btn-outline-success popup-button" onClick={() => setIsRelatedOpen(!isRealatedOpen)}>Связанные объекты</button>
            </div>

            {
                isRealatedOpen ? <ListItemsControl coords={popup.current._latlng} current={host} /> : null
            }
        </Popup>
    )
}





